// src/components/Booking/ServiceSelector.js
import React, { useState, useEffect } from 'react';
import { useBooking } from '../../contexts/BookingContext';
import salonDetailsService from '../../services/salonDetailsService';
import { formatPriceFCFA, formatDuration } from '../../utils/formatters';
import './ServiceSelector.css';

const ServiceSelector = ({ salonId, onClose }) => {
  const { addService, selectedServices } = useBooking();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    loadServices();
  }, [salonId]);

  const loadServices = async () => {
    try {
      setLoading(true);
      const data = await salonDetailsService.getSalonServices(salonId);
      setServices(data);
    } catch (error) {
      console.error('Erreur chargement services:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectService = (service) => {
    addService(service);
    onClose();
  };

  const isServiceSelected = (serviceId) => {
    return selectedServices.some(s => s.id === serviceId);
  };

  // Extraire catégories uniques
  const availableCategories = salonDetailsService.getUniqueCategories(services);

  // Filtrer services
  const filteredServices = salonDetailsService.filterServicesByCategory(services, activeCategory);

  return (
    <div className="service-selector-overlay" onClick={onClose}>
      <div className="service-selector-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Ajouter une prestation</h2>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        {loading ? (
          <div className="modal-loading">
            <div className="spinner"></div>
            <p>Chargement des services...</p>
          </div>
        ) : (
          <>
            {/* Tabs catégories */}
            <div className="modal-tabs">
              <button
                className={`tab-btn ${activeCategory === 'all' ? 'active' : ''}`}
                onClick={() => setActiveCategory('all')}
              >
                Tous
              </button>
              {availableCategories.map((category) => (
                <button
                  key={category}
                  className={`tab-btn ${activeCategory === category ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category)}
                >
                  {salonDetailsService.capitalizeFirstLetter(category)}
                </button>
              ))}
            </div>

            {/* Liste services */}
            <div className="modal-content">
              {filteredServices.length === 0 ? (
                <p className="no-services">Aucun service disponible</p>
              ) : (
                <div className="services-list">
                  {filteredServices.map((service) => {
                    const isSelected = isServiceSelected(service.id);
                    return (
                      <div 
                        key={service.id} 
                        className={`service-item ${isSelected ? 'selected' : ''}`}
                      >
                        <div className="service-item-info">
                          <h3>{service.name}</h3>
                          {service.description && (
                            <p className="service-description">{service.description}</p>
                          )}
                          <div className="service-meta">
                            <span>⏱️ {formatDuration(service.duration)}</span>
                            <span className="service-price">{formatPriceFCFA(service.price)}</span>
                          </div>
                        </div>
                        <button
                          className="btn-select"
                          onClick={() => handleSelectService(service)}
                          disabled={isSelected}
                        >
                          {isSelected ? '✓ Déjà ajouté' : 'Choisir'}
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ServiceSelector;